export const blocEConstants = {
  GET_BLOCE_REQUEST: 'GET_BLOCE_REQUEST',
  GET_BLOCE_SUCCESS: 'GET_BLOCE_SUCCESS',
  GET_BLOCE_FAILURE: 'GET_BLOCE_FAILURE',

  UPDATE_BLOCE_REQUEST: 'UPDATE_BLOCE_REQUEST',
  UPDATE_BLOCE_SUCCESS: 'UPDATE_BLOCE_SUCCESS',
  UPDATE_BLOCE_FAILURE: 'UPDATE_BLOCE_FAILURE',
};
